import { TTypeOfCreateApkModalWindow } from './createApkContext';
import { IFileData, ICreateApk, TApkType, TParametersOfApkType } from 'types';

export enum CreateApkActionTypes {
	CHANGE_VERSION_NAME = 'CHANGE_VERSION_NAME',
	CHANGE_VERSION_CODE = 'CHANGE_VERSION_CODE',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_APPLICATION_ID = 'CHANGE_APPLICATION_ID',
	SET_PARAMETER_OF_APK_TYPE = 'SET_PARAMETER_OF_APK_TYPE',
	SET_ID_APK_TYPE = 'SET_ID_APK_TYPE',
	TOGGLE_CUTOVER_BEFORE_UPDATE = 'TOGGLE_CUTOVER_BEFORE_UPDATE',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVersionName {
	type: CreateApkActionTypes.CHANGE_VERSION_NAME;
	payload: {
		versionName: string;
	};
}

interface IChangeVersionCode {
	type: CreateApkActionTypes.CHANGE_VERSION_CODE;
	payload: {
		versionCode: string;
	};
}

interface IChangeDescription {
	type: CreateApkActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeApplicationId {
	type: CreateApkActionTypes.CHANGE_APPLICATION_ID;
	payload: {
		applicationId: string;
	};
}

interface ISetParameterOfApkType {
	type: CreateApkActionTypes.SET_PARAMETER_OF_APK_TYPE;
	payload: {
		parameterOfApkType: Nullable<TParametersOfApkType>;
	};
}

interface ISetIDApkType {
	type: CreateApkActionTypes.SET_ID_APK_TYPE;
	payload: {
		IDApkType: Nullable<TApkType>;
	};
}

interface IToggleCutoverBeforeUpdate {
	type: CreateApkActionTypes.TOGGLE_CUTOVER_BEFORE_UPDATE;
}

interface IChangeFileHash {
	type: CreateApkActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetDataForSubmit {
	type: CreateApkActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateApk | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateApkModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateApkActionTypes.RESET_FIELDS;
}

export type TCreateApkAction =
	| IChangeVersionName
	| IChangeVersionCode
	| IChangeDescription
	| IChangeApplicationId
	| ISetParameterOfApkType
	| ISetIDApkType
	| IToggleCutoverBeforeUpdate
	| IChangeFileHash
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
